import styles from "./styles/vocal-remover-generating.module.scss";
import Image from "next/image";
import generatingIcon from "@/assets/icons/generating-icon.svg";
import FilledButton from "@/components/common/filled-button";
import React from "react";
import { useMobile } from "@/hooks/use-responsive";
import { useCancelVocalRemove } from "@/components/pages/vocal-remover/hooks/use-cancel-vocal-remove";
import useProgressData from "@/components/pages/convert/hooks/use-progress-data";

interface VocalRemoverGeneratingProps {
  percent: number;
}

const VocalRemoverGenerating = ({ percent }: VocalRemoverGeneratingProps) => {
  const { isMobile } = useMobile();
  const { cancelVocalRemove } = useCancelVocalRemove();
  const { displayPercent } = useProgressData(percent, "");
  return (
    <div className={styles.generating_wrapper}>
      <div className={styles.header}>
        <Image src={generatingIcon} alt={"generating"} />
        <div>Generating</div>
      </div>
      <div className={styles.progress_container}>
        <div className={styles.percents}>{displayPercent}%</div>
        <div className={styles.progress_bar}>
          <div
            className={styles.progress}
            style={{ width: `${displayPercent}%` }}
          />
        </div>
      </div>
      <FilledButton
        text={"CANCEL"}
        padding={isMobile ? "9px 22px" : "12px 24px"}
        backgroundColor={"#E64C4C"}
        color={"#F2F2F2"}
        onClick={cancelVocalRemove}
      />
    </div>
  );
};

export default VocalRemoverGenerating;
